import type { ReactNode } from "react"

interface SimpleTableProps {
  caption: string
  /** Column headings; the first is the (possibly empty) row-header column. */
  columns: string[]
  rows: { header: string; cells: ReactNode[] }[]
}

export const SimpleTable = ({ caption, columns, rows }: SimpleTableProps) => (
  <div
    role="region"
    aria-label={caption}
    tabIndex={0}
    className="border-border bg-card focus-visible:ring-ring overflow-x-auto rounded-lg border outline-none focus-visible:ring-2"
  >
    <table className="w-full border-collapse text-left text-sm">
      <caption className="sr-only">{caption}</caption>
      <thead>
        <tr className="bg-muted">
          {columns.map((c, i) => (
            <th key={i} scope="col" className="px-4 py-3 text-[13px] font-semibold">
              {c}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map(({ header, cells }, row) => (
          <tr key={`${header}-${row}`} className="border-border border-t">
            <th scope="row" className="px-4 py-3 align-top font-medium">
              {header}
            </th>
            {cells.map((cell, i) => (
              <td key={i} className="px-4 py-3 align-top">
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)
